import { render, staticRenderFns } from "./DynamicAddress.vue?vue&type=template&id=dc3fb57e&"
import script from "./DynamicAddress.vue?vue&type=script&lang=js&"
export * from "./DynamicAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports